var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTelegramMiniApps = function SvgTelegramMiniApps(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_9575_201513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 112C86.9279 112 112 86.9279 112 56C112 25.0721 86.9279 0 56 0C25.0721 0 0 25.0721 0 56C0 86.9279 25.0721 112 56 112Z",
    fill: "url(#paint0_linear_9575_201513)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7903 54.9397C41.7622 47.981 52.4126 43.3934 57.7416 41.1769C72.9569 34.8483 76.1185 33.749 78.1791 33.7127C78.6324 33.7047 79.6458 33.817 80.3022 34.3497C80.8565 34.7994 81.009 35.407 81.0819 35.8334C81.1549 36.2598 81.2458 37.2312 81.1736 37.9902C80.349 46.6535 76.7814 67.6771 74.9663 77.3802C74.1983 81.4859 72.6861 82.8625 71.222 82.9972C68.0404 83.29 65.6244 80.8946 62.5428 78.8746C57.7207 75.7136 54.9966 73.7459 50.3159 70.6615C44.9066 67.0968 48.4132 65.1376 51.496 61.9357C52.3027 61.0978 66.3212 48.3469 66.5925 47.1902C66.6264 47.0456 66.6579 46.5063 66.3376 46.2216C66.0172 45.9368 65.5444 46.0342 65.2032 46.1116C64.7196 46.2214 57.0163 51.313 42.0932 61.3865C39.9067 62.8879 37.9261 63.6195 36.1517 63.5812C34.1954 63.5389 30.4325 62.4751 27.6351 61.5658C24.204 60.4505 21.477 59.8608 21.7144 57.9666C21.8381 56.98 23.1967 55.971 25.7903 54.9397Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9575_201513",
    x1: 5600,
    y1: 0,
    x2: 5600,
    y2: 11116.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9575_201513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTelegramMiniApps);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram-mini-apps.4944a3520a3a29e7fa7f5b5412d1ed5d.svg";